export const caseStudies = [
  {
    id: "1",
    slug: "navya-by-nirali",
    title: "Navya by Nirali",
    category: "Fashion",
    metaTitle: "Discover how HJ Sysweb enhanced Navya by Nirali’s online presence with impactful storytelling, seamless shopping experience, and improved digital visibility in the ethnic fashion industry.",
    metaDesc: "Navya by Nirali Case Study | Digital Growth by HJ Sysweb",
   thumbnail: "/case-study/navya.png",
    heroImage: "/case-study/banner-navya.png",
    mainImage: "/case-study/navya/navya-laptop.png",
    description:
      "Celebrating Indian craftsmanship through timeless elegance  where heritage meets modern fashion to create stunning ensembles loved by women across the globe.",
    longDescription:
      "Navya by Nirali brings the essence of India’s rich textile artistry to contemporary women’s wear. Known for intricate handwork, vibrant fabrics, and exclusive festive collections, the brand reflects tradition with a modern edge crafted for today’s confident, fashion-forward women.",
    capabilities: [
      "Brand Development",
      "UX/UI Design",
      "Website Development",
      "Copywriting",
      "SEO",
      "Digital Marketing",
    ],
    projectDetails: {
      client: "Navya by Nirali",
      services: [
        "E-commerce Website",
        "Brand Identity",
        "SEO",
        "Social Media Marketing",
      ],
      technology: ["WordPress", "PHP", "HTML", "CSS"],
      location: { country: "India", flag: "/ind.webp" },
      projectDetails2:
        "A luxury ethnic fashion label redefining traditional wear with modern craftsmanship. We helped the brand create an impactful online identity blending stunning visuals, immersive storytelling, and seamless digital experiences that connect emotionally with its audience and inspire every woman to embrace her cultural elegance.",
      belowprojectDetails:
        "Before collaborating with HJ Sysweb, the brand’s digital presence was limited to offline recognition. Our strategic digital transformation strengthened their online visibility, enhanced engagement, and positioned Navya by Nirali among the leading names in ethnic fashion driving consistent growth in reach, brand loyalty, and customer trust.",
      sector: "Fashion & Apparel",
      digitalPlatforms: [
        {
          name: "Website",
          icon: "/icons/web.svg",
          link: "https://navyabynirali.com",
        },
        {
          name: "Instagram",
          icon: "/icons/instagram.svg",
          link: "https://instagram.com/navyabynirali",
        },
        {
          name: "Facebook",
          icon: "/icons/facebook.svg",
          link: "https://facebook.com/navyabynirali",
        },
      ],
    },
    gallery: [
      "/case-study/navya/navya-g1.png",
      "/case-study/navya/navya-g2.png",
      "/case-study/navya/navya-g3.png",
      "/case-study/navya/navya-g4.png",
      "/case-study/navya/navya-g5.png",
      "/case-study/navya/navya-g6.png",
    ],
  },




  {
    id: "2",
    slug: "luigis-pizzarama-2",
    title: "Luigi's Pizzarama II",
    category: "Food",
        metaTitle: "Luigi’s Pizzarama II Case Study | Online Ordering Transformation",
    metaDesc: "Learn how HJ Sysweb helped Luigi’s Pizzarama II grow online with a modern website, improved local reach, and a seamless digital ordering experience that boosted sales.",
    thumbnail:
      "/case-study/Luigis/Luigi's Pizzarama II Elkins Park Social Media Posts.png",
    heroImage: "/case-study/Luigis/Luigi's Pizzarama II Website Banner Image.webp",
    mainImage: "/case-study/Luigis/Luigi_s Pizzarama II Website on Laptop.webp",
    description:
      "Crafting an authentic Italian flavor experience blending tradition, taste, and technology to bring Elkins Park’s favorite pizzeria closer to its community online.",
    longDescription:
      "Luigi’s Pizzarama II in Elkins Park, PA, is known for its fresh, hand-tossed pizzas and family-inspired recipes that have delighted locals for years. The brand represents passion for authentic Italian food, warm hospitality, and a commitment to serving quality meals that bring families together.",
    capabilities: [
      "Brand Development",
      "UX/UI Design",
      "Website Development",
      "Copywriting",
      "SEO",
      "Digital Marketing",
    ],
    projectDetails: {
      client: "Luigi's Pizzarama II",
      services: [
        "E-commerce Website",
        "Brand Identity",
        "SEO",
        "Social Media Marketing",
      ],
      technology: ["Wix", "PHP", "HTML", "CSS"],
      location: { country: "USA", flag: "/usa.webp" },
      projectDetails2:
        "Luigi’s Pizzarama II is a takeaway pizzeria that celebrates real Italian flavor. Our team created a modern online experience that highlights their menu, makes ordering effortless, and reflects their warm local charm engaging customers through visually appetizing content, streamlined navigation, and storytelling that mirrors their culinary passion.",
      belowprojectDetails:
        "Earlier, Luigi’s digital footprint didn’t reflect its rich culinary heritage. Partnering with HJ Sysweb brought a complete transformation enhanced visibility, stronger online orders, and higher customer engagement. Today, Luigi’s Pizzarama II continues to grow as a recognizable neighborhood favorite, powered by an elevated digital experience.",
      sector: "Fashion & Apparel",
      digitalPlatforms: [
        {
          name: "Website",
          icon: "/icons/web.svg",
          link: "https://www.luigispizzarama2.com/",
        },
        {
          name: "Instagram",
          icon: "/icons/instagram.svg",
          link: "https://www.instagram.com/luigispizzarama2/?hl=en",
        },
        {
          name: "Facebook",
          icon: "/icons/facebook.svg",
          link: "https://www.facebook.com/luigispizzarama2/",
        },
      ],
    },
    gallery: [
      "/case-study/Luigis/Luigi's Pizzarama II Website on Pizzeria Gallery.webp",
      "/case-study/Luigis/Luigi_s Pizzarama II Website Analytics Data.webp",
      "/case-study/Luigis/Luigi_s Pizzarama II Website Google Search Traffic Data.webp",
    ],
  },




  {
    id: "3",
    slug: "pizzainhorsham",
    title: "Main Street Pizzeria & Grille",
    category: "Food",
        metaTitle: "Main Street Pizzeria & Grille Case Study | Pizza in Horsham",
    metaDesc: "Explore how HJ Sysweb transformed Main Street Pizzeria & Grille into Horsham’s top online pizza brand through smart design, SEO strategy, and improved customer engagement.",
    thumbnail:
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Social Media Posts.webp",
    heroImage:
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Website Banner Design Case Study.webp",
    mainImage:
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Website on Laptop.webp",
    description:
      "Transforming a neighborhood eatery into a leading digital brand redefining how Horsham enjoys authentic pizza through innovation, design, and strategy.",
    longDescription:
      "Main Street Pizzeria & Grille, based in Horsham, Pennsylvania, is a community-trusted restaurant offering a wide variety of handcrafted pizzas and flavorful dishes. Known for its dedication to freshness and hospitality, the brand has become a local favorite for both dine-in and online food enthusiasts.",
    capabilities: [
      "Brand Development",
      "UX/UI Design",
      "Website Development",
      "Copywriting",
      "SEO",
      "Digital Marketing",
    ],
    projectDetails: {
      client: "Main Street Pizzeria & Grille",
      services: [
        "E-commerce Website",
        "Brand Identity",
        "SEO",
        "Social Media Marketing",
      ],
      technology: ["WordPress", "PHP", "HTML", "CSS"],
      location: { country: "USA", flag: "/usa.webp" },
      projectDetails2:
        "Blends culinary tradition with modern dining expectations. Our team strengthened the brand’s digital ecosystem by building an engaging website, optimizing visibility across platforms, and crafting compelling storytelling that resonates with food lovers creating a seamless connection between their signature menu and their growing customer base.",
      belowprojectDetails:
        "The brand’s online presence did not reflect its true potential. Through a focused digital strategy, enhanced user experience, and data-driven optimization, HJ Sysweb positioned Main Street Pizzeria & Grille as Horsham’s most visible and trusted pizza destination driving consistent traffic, engagement, and business growth.",
      sector: "Fashion & Apparel",
      digitalPlatforms: [
        {
          name: "Website",
          icon: "/icons/web.svg",
          link: "https://pizzainhorsham.com/",
        },
        {
          name: "Instagram",
          icon: "/icons/instagram.svg",
          link: "https://www.instagram.com/mainstreetpizzeriainhorsham/?hl=en",
        },
        {
          name: "Facebook",
          icon: "/icons/facebook.svg",
          link: "https://www.facebook.com/MainStreetPizzeriaInHorsham/posts/straight-from-the-oven-hot-fresh-just-for-you-one-bite-and-youll-know-why-main-s/1400670022067579/",
        },
      ],
    },
    gallery: [
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Offer Case Study 2.webp",
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Offer Case Study.webp",
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Menu.webp",
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Logo.webp",
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Website.webp",
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Google Search Data.webp",
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Website Analytics Traffic Data.webp",
      "/case-study/Pizza/Main Street pizzeria & Grille Horsham Website Traffic Data.webp",
    ],
  },




  {
    id: "4",
    slug: "lifestyle-branding",
    title: "Lifestyle Branding",
    category: "Entertainment",
        metaTitle: "Lifestyle Branding Case Study | Elevating an Audio Tech Brand",
    metaDesc: "See how HJ Sysweb empowered Lifestyle Branding to build a strong digital identity, enhance user experience, and compete with top Bluetooth speaker brands worldwide.",
    thumbnail: "/case-study/LS/LifeStyle Gen1 Speaker Social Media Posts.webp",
    heroImage: "/case-study/LS/LifeStyle Gen1 Speaker Website Banner.webp",
    mainImage: "/case-study/LS/LifeStyle Gen Speaker Website on Laptop.webp",
    description:
      "Amplifying innovation through design and sound turning a next-gen Bluetooth speaker brand into a powerful digital presence with global appeal.",
    longDescription:
      "Lifestyle Branding is a modern consumer-tech brand from the USA offering next-generation Bluetooth speakers that blend power, clarity, and style. With a focus on quality engineering and aesthetic design, the brand redefines how people experience music at home, outdoors, and on the move.",
    capabilities: [
      "Brand Development",
      "UX/UI Design",
      "Website Development",
      "Copywriting",
      "SEO",
      "Digital Marketing",
    ],
    projectDetails: {
      client: "Lifestyle Branding",
      services: [
        "E-commerce Website",
        "Brand Identity",
        "SEO",
        "Social Media Marketing",
      ],
      technology: ["WordPress", "PHP", "HTML", "CSS"],
      location: { country: "USA", flag: "/usa.webp" },
      projectDetails2:
        "Lifestyle Branding merges technology and lifestyle through its premium Gen 1 Bluetooth speaker range. Our team built a strong digital foundation that showcases their innovation and elevates the user journey from sleek visuals and optimized navigation to strategic storytelling that communicates the brand’s personality and connects deeply with its audience.",
      belowprojectDetails:
        "When HJ Sysweb partnered with Lifestyle Branding, the brand was emerging with limited digital exposure. Through performance-driven strategy, refined content, and optimized online presence, we helped amplify their visibility, boost website engagement, and position Lifestyle Branding as a credible competitor to global audio giants accelerating steady growth in reach and sales.",
      sector: "Fashion & Apparel",
      digitalPlatforms: [
        {
          name: "Website",
          icon: "/icons/web.svg",
          link: "https://lifestyle-branding.com/",
        },
        {
          name: "Instagram",
          icon: "/icons/instagram.svg",
          link: "https://www.instagram.com/lifestyle.speakers/",
        },
        {
          name: "Facebook",
          icon: "/icons/facebook.svg",
          link: "https://www.facebook.com/LifeStyle.speakers/",
        },
      ],
    },
    gallery: [
      "/case-study/LS/LifeStyle gen1 Speaker Website & SPeaker.webp",
      "/case-study/LS/Gen1 Bluetooth Speaker.webp",
      "/case-study/LS/Bluetooth Speaker to buy in US.webp",
      "/case-study/LS/best bluetooth speaker.webp",
      "/case-study/LS/Water resistance Gen1 Speaker.webp",
    ],
  },




  {
    id: "5",
    slug: "ayurkhyati",
    title: "Ayur Khyati",
    category: "Healthcare",
        metaTitle: "Ayur Khyati Case Study | Digital Growth in Ayurvedic Wellness",
    metaDesc: "Discover how HJ Sysweb helped Ayur Khyati expand its digital reach, enhance patient trust, and position itself as a leading Ayurvedic wellness clinic through thoughtful design and strategy.",
    thumbnail: "/case-study/Ayur-Khyati/ayur.webp",
    heroImage: "/case-study/Ayur-Khyati/Ayur-Khyati-Hospital-Website Banner.webp",
    mainImage:
      "/case-study/Ayur-Khyati/Ayur-Khyati-Hospital-Website-on-Laptop.webp",
    description:
      "Reviving ancient wellness through modern digital transformation connecting Ayurveda’s healing essence with people seeking natural healthcare solutions online.",
    longDescription:
      "Ayur Khyati is a trusted Ayurvedic wellness clinic dedicated to restoring balance through holistic treatments and natural remedies. With a mission to promote authentic healing, the clinic provides personalized therapies for lifestyle disorders and chronic health issues, combining traditional knowledge with modern wellness care.",
    capabilities: [
      "Brand Development",
      "UX/UI Design",
      "Website Development",
      "Copywriting",
      "SEO",
      "Digital Marketing",
    ],
    projectDetails: {
      client: "Ayur Khyati",
      services: [
        "E-commerce Website",
        "Brand Identity",
        "SEO",
        "Social Media Marketing",
      ],
      technology: ["WordPress", "PHP", "HTML", "CSS"],
      location: { country: "India", flag: "/ind.webp" },
      projectDetails2:
        "Ayur Khyati stands for purity, trust, and the timeless science of Ayurveda. Our team designed a serene digital experience that reflects the brand’s philosophy creating an informative, patient-friendly platform with engaging content, clear service navigation, and a strong online identity that builds confidence and credibility among health-conscious audiences.",
      belowprojectDetails:
        "With the expertise of HJ Sysweb, Ayur Khyati transitioned from a limited digital presence to a trusted online healthcare destination. Our strategic approach enhanced visibility, streamlined patient interaction, and established a consistent brand voice. Today, Ayur Khyati stands as a recognized leader in holistic wellness with stronger reach and engagement.",
      sector: "Fashion & Apparel",
      digitalPlatforms: [
        {
          name: "Website",
          icon: "/icons/web.svg",
          link: "https://ayurkhyati.com/",
        },
        {
          name: "Instagram",
          icon: "/icons/instagram.svg",
          link: "https://www.instagram.com/ayur_khyati/?hl=en",
        },
        {
          name: "Facebook",
          icon: "/icons/facebook.svg",
          link: "https://www.facebook.com/AurawithAyurveda/",
        },
      ],
    },
    gallery: [
      "/case-study/Ayur-Khyati/Ayurkhyati-Ayurvedic-Hospital-Logo.webp",
      "/case-study/Ayur-Khyati/Ayurkhyati-Ayurvedic-Hospital-Logo-Mockup.webp",
      "/case-study/Ayur-Khyati/Ayurkhyati-Hospital-Ayurvedic-Product-Packaging-Design.webp",
      "/case-study/Ayur-Khyati/Ayurkhyati-Hospital-Ayurvedic-Products.webp",
      "/case-study/Ayur-Khyati/ayurkhyati-hospital-brochure.webp",
      "/case-study/Ayur-Khyati/Ayurkhyati-Hospital-Newspaper-Ad.webp",
      "/case-study/Ayur-Khyati/Ayurkhyati Logo-Research-Work.webp",
      "/case-study/Ayur-Khyati/Ayurkhyati-Logo.webp",
      "/case-study/Ayur-Khyati/Ayurvedic Products by Ayur Khyati.webp",
    ],
  },




  {
    id: "6",
    slug: "snasso",
    title: "Shah & Associates CPA",
    category: "Finance & Accounting",
        metaTitle: "Shah & Associates CPA Case Study | Accounting Firm Digital Growth",
    metaDesc: "Find out how HJ Sysweb strengthened Shah & Associates CPA’s online credibility, boosted client inquiries, and built a professional digital identity for their accounting and tax services.",
    thumbnail: "/case-study/Shah/shah.webp",
    heroImage:
      "/case-study/Shah/Shah & Associates CPA USA Website Banner Image.png",
    mainImage:
      "/case-study/Shah/Shah & Associates CPA USA Website on Laptop.webp",
    description:
      "Empowering financial confidence through strategic digital innovation shaping a trusted online presence for one of the leading CPA firms in the United States.",
    longDescription:
      "Shah & Associates CPA is a full-service accounting and advisory firm specializing in tax preparation, bookkeeping, and business consulting across Pennsylvania and New York. With years of professional expertise, the firm helps individuals and businesses achieve long-term financial stability through transparent, client-centered solutions.",
    capabilities: [
      "Brand Development",
      "UX/UI Design",
      "Website Development",
      "Copywriting",
      "SEO",
      "Digital Marketing",
    ],
    projectDetails: {
      client: "Shah & Associates CPA",
      services: [
        "E-commerce Website",
        "Brand Identity",
        "SEO",
        "Social Media Marketing",
      ],
      technology: ["WordPress", "PHP", "HTML", "CSS"],
      location: { country: "USA", flag: "/usa.webp" },
      projectDetails2:
        "Shah & Associates CPA stands for precision, reliability, and financial excellence. We created a credible online platform that mirrors their professionalism featuring structured service pages, intuitive design, and compelling communication that builds trust. The result is a digital experience that simplifies client engagement and reinforces the firm’s commitment to quality.",
      belowprojectDetails:
        "Through HJ Sysweb’s strategic intervention, Shah & Associates CPA achieved a refined digital presence that aligns with its professional standards. We focused on creating a seamless online journey, improving brand perception, and enhancing digital reach helping the firm strengthen client relationships and expand its footprint across Pennsylvania and New York.",
      sector: "Fashion & Apparel",
      digitalPlatforms: [
        {
          name: "Website",
          icon: "/icons/web.svg",
          link: "https://snasso.com/",
        },
        {
          name: "Instagram",
          icon: "/icons/instagram.svg",
          link: "https://www.instagram.com/ShahAssociatesCPA/#",
        },
        {
          name: "Facebook",
          icon: "/icons/facebook.svg",
          link: "https://www.facebook.com/ShahAssociatesCPA/",
        },
        {
          name: "Twitter",
          icon: "/icons/x.svg",
          link: "https://x.com/ShahnAssociates",
        },
      ],
    },
    gallery: [
      "/case-study/Shah/remote cpa services.webp",
      "/case-study/Shah/Shah & Associates CPA letter pad.webp",
      "/case-study/Shah/Shah & Associates CPA Visiting Card.webp",
      "/case-study/Shah/virtual accounting services.webp",
      "/case-study/Shah/virtual cpa services.webp",
      "/case-study/Shah/online cpa firm.webp",
    ],
  },
];















